import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, HostBinding, inject, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appFadeInReveal]'
})
export class FadeInReveal implements AfterViewInit, OnDestroy{

  private observer?: IntersectionObserver;

  @HostBinding('class.is-visible')
  isVisible = false;

  @HostBinding('class.is-hidden')
  get isHidden(): boolean {
    return !this.isVisible;
  }

  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    this.elementRef.nativeElement.classList.add('is-hidden');
  }

  ngAfterViewInit(): void {
    if (typeof window === 'undefined') {
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      this.isVisible = true;
      this.cdr.detectChanges();
      return;
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = Math.random() * 300;

          setTimeout(() => {
            this.isVisible = true;
            this.cdr.detectChanges();
          }, delay);
          this.observer?.disconnect();
        }
      });
    }, {
      threshold: 0.1
    });

    const el = this.elementRef.nativeElement;
    this.observer.observe(el);

    const rect = el.getBoundingClientRect();
    const alreadyVisible = rect.top < window.innerHeight && rect.bottom >= 0;
    if (alreadyVisible) {
      const delay = Math.random() * 300;

      setTimeout(() => {
        this.isVisible = true;
        this.cdr.detectChanges();
      }, delay);
      this.observer.disconnect();
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

}
